import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { BrandMark } from './BrandMark';
import { appConfig } from '../config/appConfig';
import { useAuth } from '../context/AuthContext';
import { peekPreferFactoryLogin } from '../lib/factoryContext';
import { isOnboardingDone } from '../utils/onboardingSession';

export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'booting') {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas px-6">
        <BrandMark size={72} />
        <div className="text-center">
          <div className="text-xl font-extrabold text-ink">{appConfig.appName}</div>
          <div className="mt-1 text-sm text-muted">加载中…</div>
        </div>
      </div>
    );
  }

  if (status === 'signed-out') {
    const fromFactoryPath =
      location.pathname === '/factory' || location.pathname.startsWith('/factory/');
    const factoryLogin = fromFactoryPath || peekPreferFactoryLogin();
    const loginTo = factoryLogin ? '/login?intent=factory' : '/login';

    if (location.pathname === '/' || location.pathname === '') {
      return <Navigate to="/welcome" replace />;
    }

    if (!isOnboardingDone()) {
      return (
        <Navigate
          to="/welcome"
          replace
          state={{ from: factoryLogin ? '/login?intent=factory' : location.pathname }}
        />
      );
    }
    return <Navigate to={loginTo} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
